import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ArtEntertainmentIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ArtEntertainmentIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7557 19.8106C21.0792 19.8106 21.3414 19.5483 21.3414 19.2248V10.9108C21.3414 10.6208 21.1293 10.3744 20.8425 10.3315L13.0233 9.15995C12.8546 9.13469 12.6834 9.18415 12.5542 9.29542C12.425 9.40669 12.3507 9.56873 12.3507 9.73923V18.0532C12.3507 18.3767 12.613 18.639 12.9365 18.639C13.26 18.639 13.5222 18.3767 13.5222 18.0532V10.4193L20.1699 11.4153V19.2248C20.1699 19.5483 20.4322 19.8106 20.7557 19.8106Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.335 13.8443C21.3829 13.5244 21.1624 13.2262 20.8425 13.1782L13.0233 12.0067C12.7033 11.9588 12.4051 12.1793 12.3572 12.4992C12.3092 12.8191 12.5297 13.1173 12.8497 13.1653L20.6689 14.3368C20.9888 14.3847 21.287 14.1642 21.335 13.8443Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.97254 18.0535C7.97254 19.5859 9.21475 20.8283 10.7472 20.8283C12.2796 20.8283 13.5222 19.5857 13.5222 18.0532C13.5222 16.5208 12.2796 15.2788 10.7472 15.2788C9.21476 15.2788 7.97254 16.5211 7.97254 18.0535ZM10.7472 19.6568C9.8618 19.6568 9.14403 18.939 9.14403 18.0535C9.14403 17.1681 9.86178 16.4503 10.7472 16.4503C11.6327 16.4503 12.3507 17.1678 12.3507 18.0532C12.3507 18.9387 11.6327 19.6568 10.7472 19.6568Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.91016 11.8411C2.91016 13.3735 4.15242 14.6158 5.68487 14.6158C7.21732 14.6158 8.45958 13.3735 8.45958 11.8411C8.45958 10.3086 7.21731 9.06636 5.68487 9.06636C4.15243 9.06636 2.91016 10.3086 2.91016 11.8411ZM5.68487 13.4443C4.79944 13.4443 4.08165 12.7265 4.08165 11.8411C4.08165 10.9556 4.79943 10.2379 5.68487 10.2379C6.57031 10.2379 7.28809 10.9556 7.28809 11.8411C7.28809 12.7265 6.5703 13.4443 5.68487 13.4443Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7918 19.2252C15.7918 20.7577 17.034 22 18.5665 22C20.0989 22 21.3414 20.7573 21.3414 19.2248C21.3414 17.6924 20.0989 16.4505 18.5665 16.4505C17.034 16.4505 15.7918 17.6928 15.7918 19.2252ZM18.5665 20.8285C17.6811 20.8285 16.9633 20.1107 16.9633 19.2252C16.9633 18.3398 17.681 17.622 18.5665 17.622C19.4519 17.622 20.1699 18.3394 20.1699 19.2248C20.1699 20.1103 19.4519 20.8285 18.5665 20.8285Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.87375 12.4265C8.19725 12.4265 8.45958 12.1646 8.45958 11.8411L8.45949 6.09588L12.7641 6.63346C12.9308 6.65428 13.0984 6.60251 13.2243 6.49132C13.3503 6.38014 13.4224 6.22022 13.4224 6.05223V3.20547C13.4224 2.91003 13.2024 2.66084 12.9092 2.62424L7.94633 2.00452C7.77962 1.9837 7.61201 2.03546 7.48607 2.14665C7.36014 2.25784 7.288 2.41775 7.288 2.58575V5.42467C7.28792 5.43035 7.28792 5.43601 7.288 5.44166L7.28809 11.8411C7.28809 12.1646 7.55025 12.4265 7.87375 12.4265ZM8.45949 4.91529V3.24918L12.2509 3.72262V5.38878L8.45949 4.91529Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ArtEntertainmentIcon;
